/* eslint-disable react/prop-types */

import React, { useState } from "react";
import { AppLayout } from "/lib/component/partial";
import { Content } from "/lib/component/base";
import { parseStringParam } from "/lib/util/params";
import Item from "../partial/ToolbarMenu/Item";
import { useRouter } from "/lib/component/util";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Card,
  CardContent,
} from "@material-ui/core";

interface PanelProps {
  //panel id from Grafana
  panelId: string;
  //time from&to (please use Grafana time format)
  from?: string;
  to?: string;
  //set refresh rate, default to 1m
  refreshInterval?: string;
  //set Entity name by selector
  entity?: string; // default to first one after query entities
  width?: number;
  height?: number;
}

const MetricPanel: React.FC<PanelProps> = ({
  panelId,
  from = "now-1h",
  to = "now",
  refreshInterval = "5m",
  entity,
  width,
  height,
}) => {
  const BASEURL =
    "https://onemetrics-dashboard.hardware-inno.gcpprodau.tbm.sh/d-solo/ca9198a7-5e13-4cc5-821f-a81034b1e1a9/tucson-2023?orgId=1";
  const router = useRouter();
  const namespace = parseStringParam(
    (router.match.params as any).namespace,
    "",
  );
  const url =
    entity !== ""
      ? `${BASEURL}&var-namespace=${namespace}&var-Entity=${entity}&from=${from}&to=${to}&panelId=${panelId}&refresh=${refreshInterval}`
      : `${BASEURL}&var-namespace=${namespace}&from=${from}&to=${to}&panelId=${panelId}&refresh=${refreshInterval}`;

  return (
    <Item>
      <iframe
        title="Grafana-panel"
        src={url}
        width={width || 450}
        height={height || 200}
      />
    </Item>
  );
};

const VENUE_VIEWS = [
  {
    name: "Bet_sold_by_venue",
    panelId: "8",
    width: 605,
  },
  {
    name: "Bet_count_by_venue",
    panelId: "10",
    width: 605,
  },
  {
    name: "printer_status",
    panelId: "4",
    width: 400,
    height: 500,
  },
  {
    name: "venue_bet_table",
    panelId: "22",
    width: 810,
    height: 500,
  },
  {
    name: "venue_bet_table",
    panelId: "21",
    width: 1220,
    height: 700,
  },
  {
    name: "CPU_status",
    panelId: "5",
    width: 1220,
    height: 350,
  },
  {
    name: "CPU_status",
    panelId: "7",
    width: 1220,
    height: 350,
  },
];

export const MetricsView = () => {
  const [timeRange, setTimeRange] = useState("-1d");

  const handleTimeChange = (event: any) => {
    setTimeRange(event.target.value);
  };

  const TimeSelector = () => {
    return (
      <Box component="section" width={600}>
        <FormControl fullWidth>
          <InputLabel id="time-selector">Select time Range</InputLabel>
          <Select
            labelId="time-selector"
            id="time-selector"
            value={timeRange || "-3h"}
            label="Time Range"
            onChange={handleTimeChange}
          >
            {/* <MenuItem value="-5m">Last 5 minutes</MenuItem> */}
            <MenuItem value="-15m">Last 15 minutes</MenuItem>
            <MenuItem value="-30m">Last 30 minutes</MenuItem>
            <MenuItem value="-1h">Last 1 hour</MenuItem>
            <MenuItem value="-3h">Last 3 hours</MenuItem>
            <MenuItem value="-6h">Last 6 hours</MenuItem>
            <MenuItem value="-12h">Last 12 hours</MenuItem>
            <MenuItem value="-1d">Last 1 day</MenuItem>
            {/* <MenuItem value="-3d">Last 3 days</MenuItem>
                      <MenuItem value="-7d">Last week</MenuItem>
                      <MenuItem value="-30d">Last month</MenuItem> */}
          </Select>
        </FormControl>
      </Box>
    );
  };

  return (
    <>
      <AppLayout>
        <Content marginBottom>
          <Box style={{ padding: "10px" }}>
            <TimeSelector />
            <Card style={{ marginTop: "10px" }}>
              <CardContent
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "start",
                  alignItems: "center",
                  gap: "10px",
                }}
              >
                {VENUE_VIEWS.map((view, index) => (
                  <MetricPanel
                    panelId={view.panelId}
                    from={`now${timeRange}`}
                    to="now"
                    width={view.width || 400}
                    height={view.height || 300}
                    key={index}
                  />
                ))}
              </CardContent>
            </Card>
          </Box>
        </Content>
      </AppLayout>
    </>
  );
};


